import { List } from 'immutable';
import { embedConstants } from '../constants';

export function embeds(state = {}, action) {
  switch (action.type) {
    case embedConstants.EMBED_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case embedConstants.EMBED_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case embedConstants.EMBED_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: List([]),
        listError: action.error
      };
    case embedConstants.EMBED_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case embedConstants.EMBED_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case embedConstants.EMBED_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case embedConstants.EMBED_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case embedConstants.EMBED_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const embedIndex = state.items.findIndex(val => val.id === action.response.id);

      if (embedIndex === -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(embedIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case embedConstants.EMBED_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case embedConstants.EMBED_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case embedConstants.EMBED_DELETE_SUCCESS: {
      const { embedId } = action;

      if (!state.items) {
        return state;
      }

      const embedIndex = state.items.findIndex(val => val.id === embedId);

      if (embedIndex === -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(embedIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case embedConstants.EMBED_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case embedConstants.EMBED_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null,
        deleteError: null
      };
    default:
      return state;
  }
}
